<div class="time-logs-container timelogs-design-view">
  <div class="time-logs-header">
    <h3>Time logs</h3>
    <div class="header-actions">
      <div class="view-toggle">
        <button pButton type="button" icon="pi pi-list" class="p-button-text" [class.active]="viewMode === 'list'"
          (click)="toggleView('list')" pTooltip="List View" tooltipPosition="top"></button>
        <button pButton type="button" icon="pi pi-th-large" class="p-button-text" [class.active]="viewMode === 'card'"
          (click)="toggleView('card')" pTooltip="Card View" tooltipPosition="top"></button>
      </div>
      <app-timesheet-export *ngIf="showExport && projectId" [projectId]="projectId" [projectName]="projectName || null"
        [users]="projectMembers" [initialMemberIds]="selectedUserIds" [initialRange]="selectedDateRange"
        [baseZIndex]="70000"></app-timesheet-export>
      <button *ngIf="showLogMoreButton" pButton type="button" [label]="taskId ? 'Log more time' : 'Log time'"
        icon="ri-add-line" class="btn-theme1" (click)="taskId ? onLogMoreTimeClick() : onManualLogTimeClick()"></button>
    </div>
  </div>

  <!-- Filters Section -->
  <div class="filters-section" *ngIf="projectId">
    <div class="filters-container">
      <!-- User Filter -->
      <div class="filter-field">
        <label>Filter by User</label>
        <app-user-selector [projectId]="projectId" [users]="projectMembers" [selectedUserIds]="selectedUserIds"
          [multiSelect]="true" placeholder="Select users..."
          (selectedUsersChange)="onUserFilterChange($event)"></app-user-selector>
      </div>

      <!-- Date Range Filter -->
      <div class="filter-field">
        <label>Filter by Date Range</label>
        <p-calendar [(ngModel)]="selectedDateRange" selectionMode="range" dateFormat="M dd, yy" [showIcon]="true"
          placeholder="Select date range" [showButtonBar]="true" (onSelect)="onDateRangeChange()"
          (onClearClick)="selectedDateRange = null; onDateRangeChange()"></p-calendar>
      </div>

      <!-- Date Presets -->
      <div class="filter-field date-presets-field">
        <label>Quick Date Filters</label>
        <div class="date-presets">
          <button *ngFor="let preset of datePresets" type="button" class="preset-chip"
            (click)="onDatePresetSelect(preset.value)">
            {{ preset.label }}
          </button>
        </div>
      </div>

      <!-- Clear Filters -->

    </div>
    <div class="filter-actions mt-4">
      <button pButton type="button" label="Clear Filters" icon="pi pi-filter-slash" class="p-button-text p-button-sm"
        (click)="clearFilters()" [disabled]="selectedUserIds.length === 0 && !selectedDateRange"></button>
    </div>
  </div>

  <!-- <pre>{{ projectMembers | json }}</pre> -->

  <!-- Filtered Totals -->
  <div class="filtered-totals" *ngIf="timeLogs.length > 0">
    <div class="total-item total-info" pTooltip="Total hours logged based on current filters" tooltipPosition="top">
      <i class="pi pi-info-circle"></i>
      <span class="label">Filtered totals</span>
    </div>
    <div class="total-item total-logged" pTooltip="Total time logged" tooltipPosition="top">
      <span class="label">Logged</span>
      <span class="value">{{ totalLogged.toFixed(2) }}h ({{ totalLogged.toFixed(2) }})</span>
    </div>
    <div class="total-item total-billable" pTooltip="Total billable hours" tooltipPosition="top">
      <span class="label">Billable</span>
      <span class="value">{{ totalBillable.toFixed(2) }}h ({{ totalBillable.toFixed(2) }})</span>
    </div>
    <div class="total-item total-non-billable" pTooltip="Total non-billable hours" tooltipPosition="top">
      <span class="label">Non-billable</span>
      <span class="value">{{ totalNonBillable.toFixed(2) }}h ({{ totalNonBillable.toFixed(2) }})</span>
    </div>
  </div>

  <!-- Loading State -->
  <!-- Skeleton Loading State -->
  <div *ngIf="isLoading" class="time-logs-table-container">
    <table class="time-logs-table">
      <thead>
        <tr>
          <th>WHO</th>
          <th>PROJECT</th>
          <th>DESCRIPTION</th>
          <th>DATE</th>
          <th>START</th>
          <th>TIME</th>
          <th>HOURS</th>
          <th>BILLABLE</th>
          <th>INVOICED</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let _ of skeletonRows" class="time-log-row">
          <td class="who-cell">
            <div class="user-info">
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton width="8rem"></p-skeleton>
            </div>
          </td>
          <td class="project-cell"><p-skeleton width="8rem"></p-skeleton></td>
          <td class="description-cell"><p-skeleton width="100%"></p-skeleton></td>
          <td class="date-cell"><p-skeleton width="6rem"></p-skeleton></td>
          <td class="start-cell"><p-skeleton width="4rem"></p-skeleton></td>
          <td class="time-cell"><p-skeleton width="4rem"></p-skeleton></td>
          <td class="hours-cell"><p-skeleton width="3rem"></p-skeleton></td>
          <td class="billable-cell"><p-skeleton width="2rem"></p-skeleton></td>
          <td class="invoiced-cell"><p-skeleton width="2rem"></p-skeleton></td>
          <td class="actions-cell">
            <div class="inline-actions">
              <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && timeLogs.length === 0" class="empty-state blue-button">
    <i class="pi pi-clock"></i>
    <span>No time logs found</span>
    <button *ngIf="showLogMoreButton" pButton type="button" [label]="taskId ? 'Log time' : 'Log time'" icon="pi pi-plus"
      class="p-button-sm" (click)="taskId ? onLogMoreTimeClick() : onManualLogTimeClick()"></button>
  </div>

  <!-- Time Logs Table (List View) -->
  <div *ngIf="!isLoading && timeLogs.length > 0 && viewMode === 'list'" class="time-logs-table-container">
    <table class="time-logs-table">
      <thead>
        <tr>
          <th pTooltip="User who logged the time" tooltipPosition="top">WHO</th>
          <th pTooltip="Project Name" tooltipPosition="top">PROJECT</th>
          <th pTooltip="Description of the work done" tooltipPosition="top">DESCRIPTION</th>
          <th pTooltip="Date of the log" tooltipPosition="top">DATE</th>
          <th pTooltip="Start time" tooltipPosition="top">START</th>
          <th pTooltip="Duration" tooltipPosition="top">TIME</th>
          <th pTooltip="Duration in decimal hours" tooltipPosition="top">HOURS</th>
          <th pTooltip="Is this time billable?" tooltipPosition="top">BILLABLE</th>
          <th pTooltip="Has this been invoiced?" tooltipPosition="top">INVOICED</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of timeLogs" class="time-log-row">
          <td class="who-cell">
            <div class="user-info" [pTooltip]="getUserName(log)" tooltipPosition="top">
              <img class="user-avatar" [src]="getUserAvatar(log)" [alt]="getUserName(log)" />
              <span class="user-name">{{ getUserName(log) }}</span>
            </div>
          </td>
          <td class="project-cell">
            <span class="project-name" [pTooltip]="log.projectId?.name || projectName || 'No Project'"
              tooltipPosition="top">
              {{ log.projectId?.name || projectName || '—' }}
            </span>
          </td>
          <td class="description-cell">
            <span class="description" [pTooltip]="log.description || 'No description'" tooltipPosition="top">{{
              log.description || '—' }}</span>
          </td>
          <td class="date-cell" [pTooltip]="(log.startTime | date:'fullDate') || ''" tooltipPosition="top">
            <span class="badge date-badge">{{ formatDate(log.startTime) }}</span>
          </td>
          <td class="start-cell"
            [pTooltip]="(log.startTime | date:'shortTime') + ' - ' + (log.endTime | date:'shortTime')"
            tooltipPosition="top">
            <span class="badge start-badge">{{ formatTime(log.startTime) }}</span>
          </td>
          <td class="time-cell">
            <span class="badge duration-badge" [pTooltip]="formatDuration(log.duration)" tooltipPosition="top">{{
              formatDuration(log.duration) }}</span>
          </td>
          <td class="hours-cell" [pTooltip]="formatDecimalHours(log.duration) + ' hours'" tooltipPosition="top">
            <span class="badge hours-badge">{{ (log.duration / 3600).toFixed(2) }}</span>
          </td>
          <td class="billable-cell">
            <span *ngIf="log.isBillable" class="badge billable-badge" pTooltip="Billable" tooltipPosition="top">
              <i class="pi pi-check"></i>
            </span>
            <span *ngIf="!log.isBillable" class="badge non-billable-badge" pTooltip="Non-billable"
              tooltipPosition="top">—</span>
          </td>
          <td class="invoiced-cell">
            <span *ngIf="log.isInvoiced" class="badge invoiced-badge" pTooltip="Invoiced" tooltipPosition="top">
              <i class="pi pi-check"></i>
            </span>
            <span *ngIf="!log.isInvoiced" class="badge status-badge" pTooltip="Not invoiced"
              tooltipPosition="top">—</span>
          </td>
          <td class="actions-cell">
            <div class="inline-actions">
              <button *ngIf="showEditButton" pButton type="button" icon="pi pi-pencil"
                class="p-button-text p-button-rounded p-button-sm action-btn edit-btn" (click)="onEditTimeLog(log)"
                pTooltip="Edit" tooltipPosition="top"></button>
              <button *ngIf="showDeleteButton" pButton type="button" icon="pi pi-trash"
                class="p-button-text p-button-rounded p-button-sm action-btn delete-btn" (click)="onDeleteTimeLog(log)"
                pTooltip="Delete" tooltipPosition="top"></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Time Logs Card View -->
  <div *ngIf="!isLoading && timeLogs.length > 0 && viewMode === 'card'" class="time-logs-card-container timelog-fixed">
    <div class="time-log-card" *ngFor="let log of timeLogs">
      <div class="card-header">
        <div class="user-info">
          <img class="user-avatar" [src]="getUserAvatar(log)" [alt]="getUserName(log)" />
          <div class="user-details">
            <span class="user-name">{{ getUserName(log) }}</span>
            <span class="log-date">{{ formatDate(log.startTime) }}</span>
          </div>
        </div>
        <div class="card-actions">
          <button *ngIf="showEditButton" pButton type="button" icon="pi pi-pencil"
            class="p-button-text p-button-rounded p-button-sm action-btn edit-btn" (click)="onEditTimeLog(log)"
            pTooltip="Edit" tooltipPosition="top"></button>
          <button *ngIf="showDeleteButton" pButton type="button" icon="pi pi-trash"
            class="p-button-text p-button-rounded p-button-sm action-btn delete-btn" (click)="onDeleteTimeLog(log)"
            pTooltip="Delete" tooltipPosition="top"></button>
        </div>
      </div>

      <div class="card-body">
        <div class="project-section" *ngIf="log.projectId || projectName">
          <span class="label">Project</span>
          <p class="project-name">{{ log.projectId?.name || projectName }}</p>
        </div>

        <div class="description-section">
          <span class="label">Description</span>
          <p class="description">{{ log.description || '—' }}</p>
        </div>

        <div class="metrics-grid">
          <div class="metric-item">
            <span class="label">Time</span>
            <span class="badge duration-badge">{{ formatDuration(log.duration) }}</span>
          </div>
          <div class="metric-item">
            <span class="label">Hours</span>
            <span class="badge hours-badge">{{ (log.duration / 3600).toFixed(2) }}</span>
          </div>
          <div class="metric-item">
            <span class="label">Start</span>
            <span class="badge start-badge">{{ formatTime(log.startTime) }}</span>
          </div>
        </div>

        <div class="status-badges">
          <span class="status-badge" [ngClass]="log.isBillable ? 'billable' : 'non-billable'">
            <i class="pi" [ngClass]="log.isBillable ? 'pi-check' : 'pi-times'"></i>
            {{ log.isBillable ? 'Billable' : 'Non-billable' }}
          </span>
          <span class="status-badge" [ngClass]="log.isInvoiced ? 'invoiced' : 'not-invoiced'">
            <i class="pi" [ngClass]="log.isInvoiced ? 'pi-check' : 'pi-circle'"></i>
            {{ log.isInvoiced ? 'Invoiced' : 'Not invoiced' }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Log More Time Button (Bottom) -->
  <div class="log-more-footer" *ngIf="!isLoading && timeLogs.length > 0 && showLogMoreButton">
    <button pButton type="button" [label]="taskId ? 'Log more time' : 'Log time'" icon="pi pi-plus"
      class="p-button-text p-button-sm" (click)="taskId ? onLogMoreTimeClick() : onManualLogTimeClick()"></button>
  </div>
</div>

<!-- Local confirm dialog to avoid z-index issues with parent stacking context -->
<p-dialog [(visible)]="showDeleteConfirm" [modal]="true" [closable]="false"
  [style]="{ width: '300px' }" [baseZIndex]="999999" appendTo="body">
  <ng-template pTemplate="header">
    <span><i class="pi pi-exclamation-triangle me-2"></i>Delete Confirmation</span>
  </ng-template>
  <p>Are you sure you want to delete this time log?</p>
  <ng-template pTemplate="footer">
    <button pButton label="No" class="p-button-text" (click)="showDeleteConfirm = false"></button>
    <button pButton label="Yes" class="p-button-danger" (click)="confirmDelete()"></button>
  </ng-template>
</p-dialog>